/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { func } from 'prop-types';
import { connect } from 'react-redux';

import p from 'polyglot/polyglot';

import { setPaymentMethodStatus as setPaymentMethodStatusAction } from 'actions/paymentMethod';

import { STATUS } from 'reducers/paymentMethod';

import Button from 'components/Button/Button';

import RegisterFreelance from '../RegisterFreelance/RegisterFreelance';

import styles from './register-cool-company.scss';

/**
 * This is the RegisterCoolCompany component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class RegisterCoolCompany extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    setPaymentMethodStatus: func.isRequired,
  };

  /**
   * Set initial state.
   */
  state = {
    showForm: false,
  };

  onClickFreelance = () => {
    const { setPaymentMethodStatus } = this.props;

    setPaymentMethodStatus(STATUS.REGISTER_FREELANCE);
  };

  onClickCoolCompany = () => {
    this.setState({
      showForm: true,
    });
  };

  /**
   * Render RegisterCoolCompany.
   *
   * @return {Object}
   */
  render() {
    const { showForm } = this.state;

    if (!showForm) {
      return (
        <div className={styles.wrapper}>
          <div className={styles.content}>
            <p>{p.t('payments.register_cool_company.title')}</p>
          </div>

          <div className={styles.button}>
            <Button wide onClick={this.onClickCoolCompany}>
              {p.t('payments.register_cool_company.agree_button')}
            </Button>
          </div>
          <div className={styles.button}>
            <Button wide onClick={this.onClickFreelance}>
              {p.t('payments.register_cool_company.freelance_button')}
            </Button>
          </div>
        </div>
      );
    }

    return <RegisterFreelance isCoolCompany />;
  }
}

export default connect(null, {
  setPaymentMethodStatus: setPaymentMethodStatusAction,
})(RegisterCoolCompany);
